"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMiddleware = exports.FETCH_ERRORS = void 0;
const cross_fetch_1 = __importStar(require("cross-fetch"));
var FETCH_ERRORS;
(function (FETCH_ERRORS) {
    FETCH_ERRORS[FETCH_ERRORS["NETWORK_FAILURE"] = 523] = "NETWORK_FAILURE";
})(FETCH_ERRORS = exports.FETCH_ERRORS || (exports.FETCH_ERRORS = {}));
const fetchMiddleware = (ctx, next) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const fetchFun = (_a = ctx.options.fetch) !== null && _a !== void 0 ? _a : cross_fetch_1.default;
    try {
        ctx.response = yield fetchFun(ctx.input, ctx.options);
    }
    catch (err) {
        // error is network error like ECONNRESET ... (https://nodejs.org/api/errors.html#errors_common_system_errors)
        // so we want to create a simple response for it so we can manage it consistently with response errors
        ctx.response = new cross_fetch_1.Response(`{ "message": "${err.code}" }`, {
            status: FETCH_ERRORS.NETWORK_FAILURE,
            statusText: err.code,
        });
    }
    return next();
});
exports.fetchMiddleware = fetchMiddleware;
//# sourceMappingURL=fetchMiddleware.js.map